import {
  IsNotEmpty,
  IsOptional,
  IsString,
  Matches,
  MaxLength,
  MinLength,
  ValidateIf,
} from 'class-validator';
import { IsMobile } from '../../validation/is-mobile';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';

/**
 * Dati anagrafici del passo profilo dell'onboarding. Salvati appena l'utente
 * passa al passo carta, così restano sul tenant anche se abbandona il pagamento.
 */
export class OnboardingProfileDto {
  @IsString()
  @IsNotEmpty()
  @MinLength(1)
  @MaxLength(100)
  @Matches(/\S/, { message: 'Inserisci un nome valido' })
  firstName!: string;

  @IsString()
  @IsNotEmpty()
  @MinLength(1)
  @MaxLength(100)
  @Matches(/\S/, { message: 'Inserisci un cognome valido' })
  lastName!: string;

  @IsString()
  @IsNotEmpty()
  ragioneSociale!: string;

  @IsString()
  @Matches(/^\d{11}$/, { message: 'La Partita IVA deve contenere esattamente 11 cifre' })
  partitaIva!: string;

  @IsString()
  @IsNotEmpty()
  indirizzoVia!: string;

  @IsString()
  @IsNotEmpty()
  indirizzoCap!: string;

  @IsString()
  @IsNotEmpty()
  indirizzoCitta!: string;

  @IsString()
  @IsNotEmpty()
  indirizzoProvincia!: string;

  @ValidateIf((o) => !o.pec)
  @IsString({ message: 'Inserisci il Codice SDI oppure la PEC' })
  @IsNotEmpty({ message: 'Inserisci il Codice SDI oppure la PEC' })
  codiceSdi!: string;

  @ValidateIf((o) => !o.codiceSdi)
  @IsString({ message: 'Inserisci il Codice SDI oppure la PEC' })
  @IsNotEmpty({ message: 'Inserisci il Codice SDI oppure la PEC' })
  pec!: string;

  /**
   * Cellulare di riferimento (opzionale). @IsOptional NON salta la validazione
   * per stringa vuota: il transform converge '' → undefined prima del check.
   * Normalizzato E.164 alla persistenza (OnboardingRepository).
   */
  @IsOptional()
  @OptionalStringTransform()
  @IsMobile()
  phone?: string;
}
